import React, { useState, useEffect } from "react";
import { Form, Field } from "react-final-form";
import { Field as VldField } from "react-final-form-html5-validation";
import classNames from "classnames";
import { toast } from "react-toastify";
import {
  Row,
  Col,
  Form as BSForm,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Nav,
  NavItem,
  NavLink,
  FormGroup,
  Label
} from "reactstrap";

import Img from "../Img";
import Button from "../Form/Button";
import Input from "../Form/Input";
import FileInput from "../Form/File";
import disableSubmit from "../../utils/disableSubmit";
import SearchTypeahead from "../Form/SearchTypeahead";

import {
  adTypes,
  countries,
  priorities,
  qualities,
} from "./constants";

const AdForm = props => {
  const [activeTab, setActiveTab] = useState(props.location && props.location.hash ? props.location.hash.substr(1) : 'info');
  const [values, setValues] = useState(props.data);
  useEffect(() => {
    setValues(props.data);
  }, [props.data])
  const toggleTab = (tab, values) => {
    setValues(values);
    if (activeTab !== tab) {
      setActiveTab(tab);
      if (tab !== 'info') {
        props.history.replace(`/ads/${props.match.params.id}#${tab}`);
      } else {
        props.history.replace(`/ads/${props.match.params.id}`);
      }
    }
  }
  return (
    <Form
      onSubmit={values => props.onSubmit({
        ...values,
        spec: {
          ...values.spec,
          excludeChannels: ((values.spec.excludeChannels || []).map(channel => channel.id)),
          includeChannels: ((values.spec.includeChannels || []).map(channel => channel.id))
        }
      })}
      initialValues={{
        ...{
          privilege: Object.keys(priorities)[0],
          country: Object.keys(countries)[1],
          quality: Object.keys(qualities)[0]
        },
        ...values,
        coverFile: {}
      }}
      render={({ handleSubmit, submitting, pristine, errors, values }) => (
        <Card className="active">
          <CardHeader>
            <Nav tabs card>
              <NavItem>
                <NavLink
                  active={activeTab === 'info'}
                  onClick={() => toggleTab('info', values)}
                >
                  مشخصات تبلیغ
                </NavLink>
              </NavItem>
              {props.data && props.data.id && props.data.spec && (
                <NavItem>
                  <NavLink
                    active={activeTab === 'spec'}
                    onClick={() => toggleTab('spec', values)}
                  >
                    تنظیمات
                    </NavLink>
                </NavItem>
              )}
            </Nav>
          </CardHeader>
          <React.Fragment>
            <CardBody>
              <BSForm
                id="channel-form"
                onSubmit={e => e.preventDefault()}
                className={classNames({ disabled: submitting })}
              >
                {activeTab === 'info' &&
                  <Row>
                    <Col xs="12" sm="4" lg="3">
                      <Field type="hidden" name="id" component={Input} />
                      <Img
                        fill="#ccc"
                        width="100"
                        height="140"
                        src={
                          values.coverFile.src ||
                          (props.data && (props.data.cover || props.data.picture) + '/r/100x140')
                        }
                        className="w-100 mb-3 rounded"
                      />
                      <VldField
                        name="coverFile"
                        id="coverFile"
                        type="file"
                        label="کاور"
                        accept="image/*"
                        component={FileInput}
                        required={!values.id}
                        valueMissing="این قسمت نمی‌تواند خالی باشد"
                        validate={value => {
                          if (value && value.file) {
                            if (value.file.type && !value.file.type.match("image.*"))
                              return "لطفاً فقط فایل عکس انتخاب کنید";
                          }
                          return undefined;
                        }}
                      />
                      <VldField
                        name="file"
                        id="file"
                        type="file"
                        label="فایل صوتی"
                        component={FileInput}
                        accept="audio/*"
                        required={!values.id}
                        valueMissing="این قسمت نمی‌تواند خالی باشد"
                        validate={value => {
                          if (value && value.file) {
                            if (value.file.type && !value.file.type.match("audio.*"))
                              return "لطفاً فقط فایل صوتی انتخاب کنید";
                          }
                          return undefined;
                        }}
                      />
                      <hr />
                      <Field
                        name="active"
                        id="active"
                        type="checkbox"
                        custom="switch"
                        options={[true, false]}
                        label="فعال"
                        component={Input}
                      />
                    </Col>
                    <Col>
                      <Row form>
                        <Col xs="12">
                          <VldField
                            name="name"
                            id="name"
                            required
                            label="عنوان تبلیغ"
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            component={Input}
                            placeholder="عنوانی برای تبلیغ وارد کنید"
                          />
                        </Col>
                        <Col xs="12" lg="6">
                          <VldField
                            name="type"
                            id="type"
                            required
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            label="نوع تبلیغ"
                            component={Input}
                            options={<React.Fragment>
                              <option />
                              {Object.keys(adTypes).map(key => (
                                <option value={key} key={key}>
                                  {adTypes[key].label}
                                </option>
                              ))}
                            </React.Fragment>}
                            type="select"
                          />
                        </Col>
                        <Col xs="12" lg="6">
                          <VldField
                            name="quality"
                            id="quality"
                            required
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            label="کیفیت"
                            component={Input}
                            options={Object.keys(qualities).map(key => (
                              <option value={key} key={key}>
                                {qualities[key].label}
                              </option>
                            ))}
                            type="select"
                          />
                        </Col>
                        <Col xs="12" lg="6">
                          <VldField
                            name="country"
                            id="country"
                            required
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            label="قابل دسترس در"
                            component={Input}
                            options={Object.keys(countries).map(key => (
                              <option value={key} key={key}>
                                {countries[key].label}
                              </option>
                            ))}
                            type="select"
                          />
                        </Col>
                        <Col xs="12" lg="6">
                          <VldField
                            name="privilege"
                            id="privilege"
                            required
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            label="اولویت"
                            component={Input}
                            options={Object.keys(priorities).map(key => (
                              <option value={key} key={key}>
                                {priorities[key].label}
                              </option>
                            ))}
                            type="select"
                          />
                        </Col>
                        <Col xs="12">
                          <VldField
                            name="link"
                            id="link"
                            required
                            label="لینک تبلیغ"
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            component={Input}
                            placeholder="http://shuffle.one"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                }
                {activeTab === 'spec' && values.spec &&
                  <Row>
                    <Col xs="12">
                      <FormGroup>
                        <Label htmlFor="tags">نمایش برای تگ</Label>
                        <Field
                          name="spec.tagIds"
                          id="tags"
                          label="تگ"
                          component={SearchTypeahead}
                          searchType="tag"
                          multiple
                        />
                      </FormGroup>
                    </Col>
                    <Col xs="12">
                      <FormGroup>
                        <Label htmlFor="include-channels">نمایش برای کانال</Label>
                        <Field
                          name="spec.includeChannels"
                          id="include-channels"
                          label="کانال"
                          component={SearchTypeahead}
                          searchType="channel"
                          multiple
                        />
                      </FormGroup>
                    </Col>
                    <Col xs="12">
                      <FormGroup>
                        <Label htmlFor="excludeChannels-channels">عدم نمایش برای کانال</Label>
                        <Field
                          name="spec.excludeChannels"
                          id="excludeChannels-channels"
                          label="کانال"
                          component={SearchTypeahead}
                          searchType="channel"
                          multiple
                        />
                      </FormGroup>
                    </Col>
                    <Col xs="12">
                      <Field
                        name="spec.allChannel"
                        id="all-channels"
                        type="checkbox"
                        custom="switch"
                        options={[true, false]}
                        label="نمایش در همهٔ کانال ها"
                        component={Input}
                      />
                    </Col>
                    <Col xs="12">
                      <Field
                        name="spec.likeChannel"
                        id="like-channels"
                        type="checkbox"
                        custom="switch"
                        options={[true, false]}
                        label="نمایش در کانال لایک‌شده‌ها"
                        component={Input}
                      />
                    </Col>
                  </Row>
                }
              </BSForm>
            </CardBody>
            <CardFooter className="position-sticky-bottom bg-light">
              <Button
                loading={submitting}
                disabled={disableSubmit({
                  submitting,
                  pristine: false,
                  errors
                })}
                className="ml-3"
                onClick={(event) => {
                  handleSubmit(event).then(response => {
                    toast.success(
                      props.data
                        ? "تغییرات با موفقیت ذخیره شد"
                        : "تبلیغ جدید ساخته شد",
                      { toastId: "ad-saved" }
                    );
                    if (typeof props.goBack === "function") props.goBack();
                  });
                }}
              >
                {props.data ? `ذخیره و بازگشت` : "ساخت تبلیغ"}
              </Button>
              {props.data && !submitting && (
                <Button
                  outline
                  loading={submitting}
                  disabled={disableSubmit({
                    submitting,
                    pristine: false,
                    errors
                  })}
                  onClick={() => {
                    handleSubmit().then(response => {
                      toast.success(
                        props.data
                          ? "تغییرات با موفقیت ذخیره شد"
                          : "تبلیغ جدید ساخته شد",
                        { toastId: "ad-saved" }
                      );
                    }).catch(err => console.log(err));
                  }}
                >
                  ذخیره
              </Button>
              )}
            </CardFooter>
          </React.Fragment>
        </Card>
      )}
    />
  );
};
export default AdForm;
